import RequestStatus from "../model/RequestStatus";
import {FeeCategoryListResponse, GetFeeCategoryListResponse} from "../model/FeeCategoryList";

export const FEE_CAT_QUERY_START = 'FEE_CAT_QUERY_START';
export const FEE_CAT_QUERY_SUCCESS = 'FEE_CAT_QUERY_SUCCESS';
export const FEE_CAT_QUERY_FAILED = 'FEE_CAT_QUERY_FAILED';

export interface FeeCatQueryStartAction {
    readonly type: string,
    readonly requestStatus: RequestStatus,
    readonly countryCode: string,
    readonly locale: string,
}

export const setFeeCatQueryStart = (countryCode: string, locale: string): FeeCatQueryStartAction => ({
    type: FEE_CAT_QUERY_START,
    requestStatus: RequestStatus.LOADING,
    countryCode: countryCode,
    locale: locale
});

export interface GetFeeCatQueryComplete {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly feeCatResponse: any;
}

export const getFeeCatQuerySuccessAction = (response: FeeCategoryListResponse): GetFeeCatQueryComplete => ({
    type: FEE_CAT_QUERY_SUCCESS,
    requestStatus: RequestStatus.SUCCESS,
    feeCatResponse: response
});

export const getFeeCatQueryFailedAction = (): GetFeeCatQueryComplete => ({
    type: FEE_CAT_QUERY_FAILED,
    requestStatus: RequestStatus.ERROR,
    feeCatResponse: null
});

